module.exports = __webpack_public_path__ + "static/media/DogTrack1.45d94fb5.jpg";